<template>
  <v-row justify="center">
    <v-dialog
      persistent
      v-model="showDialogComp"
      scrollable
      max-width="800"
      @click:outside="cancel"
    >
      <v-card>
        <v-card-title>Select POIs</v-card-title>
        <v-divider></v-divider>

        <v-card-text max-height="600">
          <v-list three-line flat>
            <v-list-item-group v-model="settings" multiple>
              <v-list-item v-for="p in poisComp" :key="p.id" @click="check(p)">
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-checkbox v-model="active" color="primary"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-content>
                    <menu-item-poi-card :poi="p"></menu-item-poi-card>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn v-on:click="cancel">cancel</v-btn>
          <v-btn v-on:click="done">done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import MenuItemPoiCard from '../components/MenuItemPoiCard'

export default {
  components: {
    MenuItemPoiCard
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    poisComp: {
      get: function() {
        return this.pois
      },
      set: function(newValue) {
        console.log('SET: ', newValue)
        this.pois = newValue
      }
    },
    showDialogComp: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        this.show = newValue
      }
    }
  },
  created: function() {
    this.$store
      .dispatch('PoiStore/getAvailablePoisForMenuItemLinking')
      .then(() => {
        console.log(
          'pois ',
          this.$store.state.PoiStore.availablePoisForSelectedMenuItemLinking
        )
        this.$store.dispatch('PoiStore/fetchPoiTypes')
        this.poisComp = this.$store.state.PoiStore.availablePoisForSelectedMenuItemLinking
        this.showDialogComp = this.showDialog
      })
  },
  methods: {
    cancel: function() {
      this.$emit('cancel')
    },
    done: async function() {
      await this.$store.dispatch('MenuItemsStore/linkMenuItemWithPois', {
        menuItemId: this.$store.state.MenuItemsStore.selectedMenuItem.id,
        poiIds: this.poiIds
      })
      await this.$store.dispatch('PoiStore/fetchPois')
      await this.$store.dispatch('PoiStore/getAvailablePoisForMenuItemLinking')

      this.poisComp = this.$store.state.PoiStore.availablePoisForSelectedMenuItemLinking

      this.$emit('done')
    },
    check: function(poi) {
      if (this.poiIds.indexOf(poi.id) === -1) {
        this.poiIds.push(poi.id)
      } else {
        this.poiIds.splice(this.poiIds.indexOf(poi.id), 1)
      }
      console.log('LOG: ', this.poiIds)
    }
  },
  data() {
    return {
      settings: [],
      poiIds: [],
      show: false,
      pois: []
    }
  }
}
</script>
